import React, { useEffect, useState } from "react";
import { Calendar, DollarSign, Tag, Search } from "lucide-react";
import useApi from "../utils/useApi";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import axios from "axios";

const BudgetCreationPopup = (props) => {
    const COMPANY_CODE = localStorage.getItem("companyCode") || "-";

  const [departmentList, setDepartmentList] = useState(null);
  const { setBudgetCreationForm, accountFromparent } = props;
  const [date, setDate] = useState("");
  const [amount, setAmount] = useState("");
  const [options, setOptions] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedOption, setSelectedOption] = useState({
    CostCenter: "",
    Description: "",
  });

  const [selectedDepartment, setSelectedDepartment] = useState({
    deptno: "",
    deptnodesc: "",
  });

  const [loading, setLoading] = useState(false);

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    type: "success",
  });
  const {
    loading: loadingpostBudget,
    data: datapostBudget,
    post: postPhysicalStockEntry,
  } = useApi();

  const today = new Date().toISOString().split("T")[0];

  // 🔹 Fetch dropdown list from API
  useEffect(() => {
    let API_PATHS = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";

    fetch(`${BASE_URL}/api/cpaysCount/${COMPANY_CODE}/costcenter/-/-`)
      .then((res) => res.json())
      .then((data) => setOptions(data))
      .catch((err) => console.error(err));
  }, []);

  // 🔹 Filter dropdown options
  const filteredOptions = options?.filter((item) =>
    item?.name?.toLowerCase().includes(search.toLowerCase())
  );

  // 🔹 Submit form
  const handleSubmit = async (e) => {
    let API_PATHS = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";

    let apiUrl = `${BASE_URL}/api/BudgetCRM`;
    e.preventDefault();

    if (date === "") {
      alert("please select date ");
      return;
    }

    if (amount === "") {
      alert("please enter amount ");
      return;
    }

    if (selectedOption.Description === "") {
      alert("please select cost center ");
      return;
    }

    if (selectedDepartment.deptno === "") {
      alert("please select department ");
      return;
    }

    setLoading(true);
    const payload = [
      {
        CmpCode: COMPANY_CODE,
        mode: "ENTRY",
        account: accountFromparent,
        budget_monthYear: date,
        budget_Amount: Number(amount),
        costcenter: selectedOption.Description,
        DEPTNO: selectedDepartment.deptno,
      },
    ];

    try {
      let serializedData = JSON.stringify(payload);

      console.log("serializedData ", serializedData);

      postPhysicalStockEntry(apiUrl, serializedData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (datapostBudget) {
      if (datapostBudget.result?.trim()?.toUpperCase() === "SAVED") {
        setDate("");
        setAmount("");

        setSearch("");

        setSelectedOption({
          CostCenter: "",
          Description: "",
        });

        setSelectedDepartment({
          deptno: "",
          deptnodesc: "",
        });

        setSnack({
          open: true,
          message: `Budget Saved Successfully `,
          type: "success",
        });
      } else {
        setSnack({
          open: true,
          message: "Failed to save Budget",
          type: "error",
        });
      }
    }
  }, [datapostBudget]);

  const handleDateChange = (e) => {
    const value = e.target.value;
    if (!value) return;

    const parts = value.split("-");
    const year = parts[0];
    const month = parts[1];
    const firstDayDate = `${year}-${month}-01`;

    setDate(firstDayDate);
  };

  const fetchDepartments = async () => {
    try {
      let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";

      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;

      const apiURL = `${apiBaseURL}/api/CpaysCount/${company_code_from_local_storage}/DEPTLIST/-/-`;
      const response = await axios.get(apiURL);
      const data = response.data;
      // console.log("Dept List:", data);
      setDepartmentList(data);
    } catch (error) {
      console.error("Error while fetching Dept list!", error);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  return (
    <div className="min-h-screen  flex items-center justify-center p-4">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-xl p-8">
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-2">
            Create Budget
          </h2>
          <p className="text-gray-500">Set up your budget allocation</p>
        </div>

        <div className="space-y-6">
          {/* Date Picker */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Date
            </label>
            <div className="relative">
              <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="date"
                value={date}
                min={today}
                onChange={(e) => handleDateChange(e)}
                required
                className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
              />
            </div>
          </div>

          {/* Budget Amount */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Budget Amount
            </label>
            <div className="relative">
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="0.00"
                required
                className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
              />
            </div>
          </div>

          {/* Searchable Dropdown */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Category
            </label>
            <div className="space-y-3">
              {/* <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="Search categories..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
                />
              </div> */}

              <div className="relative">
                <Tag className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 pointer-events-none" />
                <select
                  value={selectedOption.CostCenter}
                  onChange={(e) => {
                    const selected = options.find(
                      (item) => item.CostCenter === e.target.value
                    );

                    setSelectedOption({
                      CostCenter: selected?.CostCenter || "",
                      Description: selected?.Decription || "",
                    });
                  }}
                  required
                  className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition appearance-none bg-white cursor-pointer"
                >
                  <option value="">Select a category</option>
                  {options?.map((item) => (
                    <option key={item.CostCenter} value={item.CostCenter}>
                      {item.Decription}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Department
            </label>
            <div className="relative">
              <select
                value={selectedDepartment.deptno}
                onChange={(e) => {
                  const selected = departmentList.find(
                    (item) => item.deptno === e.target.value
                  );

                  setSelectedDepartment({
                    deptno: selected?.deptno || "",
                    deptnodesc: selected?.deptnodesc || "",
                  });
                }}
                required
                className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition appearance-none bg-white cursor-pointer"
              >
                <option value="">Select a Department</option>
                {departmentList?.map((item) => (
                  <option key={item.deptno} value={item.deptno}>
                    {item.deptnodesc}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex gap-3">
            <button
              type="button"
              onClick={() => setBudgetCreationForm((prev) => !prev)}
              className="flex-1 bg-gray-200 text-gray-700 font-semibold py-3 px-6 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-4 focus:ring-gray-300 transition"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleSubmit}
              disabled={loading}
              className="flex-1 bg-gradient-to-r from-indigo-600 to-blue-600 text-white font-semibold py-3 px-6 rounded-lg hover:from-indigo-700 hover:to-blue-700 focus:outline-none focus:ring-4 focus:ring-indigo-300 transition disabled:opacity-50 disabled:cursor-not-allowed shadow-lg"
            >
              {loading ? (
                <span className="flex items-center justify-center">
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Saving...
                </span>
              ) : (
                "Save"
              )}
            </button>
          </div>
        </div>
      </div>

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack({ ...snack, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => setSnack({ ...snack, open: false })}
          severity={snack.type}
          variant="filled"
          elevation={6}
        >
          {snack.message}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default BudgetCreationPopup;
